goog.provide('yext.storm.Toggles');

goog.require('yext');
goog.require('yext.ajax');
goog.require('yext.dialog');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

(function() {
  /**
   * @constructor
   */
  var Toggles = function(editSavingUrl) {
    this.bindLinkClick();
    this.bindFieldEdit(editSavingUrl);
    this.bindInputChange();
  };
  goog.exportSymbol('Toggles', Toggles);

  /**
   * Bind click on "Learn more" link to stop propagation.
   */
  Toggles.prototype.bindLinkClick = function() {
    $('#toggles-table').delegate('.learn-more', 'click', function(e) {
      e.stopPropagation();
    });
  };

  /**
   * Bind edit field.
   *
   * 1) Switch to editing mode on row click.
   * 2) Bind reset link.
   * 3) Bind submit button to edit field and show errors.
   */
  Toggles.prototype.bindFieldEdit = function(editSavingUrl) {
    var $table = $('#toggles-table > table > tbody');

    // Switch to editing mode on row click
    $table.delegate('tr.js-toggles:not(.toggles-row-edit)', 'click', function() {
      $(this).addClass('toggles-row-edit');
      $(this).find('.display-mode').hide();
      $(this).find('.editing-mode').show();
      togglesBindOnBeforeUnload();
      return false;
    }).delegate('tr.js-toggles .reset', 'click', function() {
      // Reset link
      $(this).parents('form')[0].reset();
      var $tr = $(this).parents('tr');
      $tr.removeClass('toggles-row-edit');
      $tr.find('.error').text('').hide();
      $tr.find('.validation-error').removeClass('validation-error');
      $tr.find('.display-mode').show();
      $tr.find('.editing-mode').hide();
      $tr.find('.submit').addClass('disabled');
      togglesBindOnBeforeUnload();
      return false;
    }).delegate('tr.js-toggles form', 'submit', function() {
      var $tr = $(this).parents('tr');
      var $div = $tr.find('div.toggle.selected');
      var $input = $tr.find('input[type=radio]:checked');
      var params = {
        'featureId': $input.data('featureId'),
        'setting': $input.val(),
      };
      $.ajax({
        url: editSavingUrl,
        dataType: 'json',
        type: 'POST',
        data: params,
        success: function(result) {
          if (result.error) {
            var errors = [];
            for (var key in result.error) {
              errors.push(result.error[key]);
              $tr.find('input.' + key).addClass('validation-error');
            }
            $tr.find('.error').html(errors.join('<br>')).show();
          } else {
            var setting = result.setting ? yext.msg('On') : yext.msg('Off');
            $tr.find('.setting .options-wrapper > .display-mode').text(setting);
            $tr.find('.reset').click();
            $tr.find('input[type=radio]').val([result.setting ? 'ON' : 'OFF']);
          }
        },
      }).error(yext.ajax.errorWrapper(function() {
        yext.dialog.showErrorDialog('Unable to update the setting.');
      }));
      return false;
    }).delegate('tr.js-toggles.toggles-row-edit .submit:not(.disabled)', 'click', function() {
      // Submit button
      $(this).parents('form').submit();
      return false;
    });
  };

  var togglesBindOnBeforeUnload = function() {
    var unsavedFields = false;
    $('.toggles-row-edit').each(function() {
      var $submit = $(this).find('.submit');
      if (!$submit.hasClass('disabled')) {
        unsavedFields = true;
        return false;
      }
    });

    if (unsavedFields) {
      window.onbeforeunload = function(e) {
        e = e || window.event;
        var message = yext.msg('You\'ve made changes that you have not saved. If you leave this page, your changes will be lost.');
        if (e) {
          e.returnValue = message;
        }
        return message;
      };
    } else {
      window.onbeforeunload = null;
    }
  };

  /**
   * When input value change, enable/disable submit button
   */
  Toggles.prototype.bindInputChange = function() {
    $('input.savable').inputchange(function() {
      $(this).closest('tr').find('.submit').removeClass('disabled');
      togglesBindOnBeforeUnload();
    });
  };
})();
